module.exports = __webpack_public_path__ + "static/media/appointment-booked.0a1f4550.svg";